// Bridge: re-export the full Projects implementation from `src/projects`
import Projects from "../projects";

export default Projects;